import { Component, ContentChild, ContentChildren, Input, QueryList, TemplateRef } from '@angular/core';


@Component({
  selector: 'split-report-table',
  templateUrl: './split-report-table.component.html',
  styleUrls: ['./split-report-table.component.scss']
})

export class SplitReportTableComponent {

  @Input() data: any;
  @Input() total: any;
  @Input() widthColumns: any = [];
  @ContentChildren('header') headers!: QueryList<TemplateRef<any>>;
  @ContentChildren('row') rows!: QueryList<TemplateRef<any>>;
  @ContentChildren('column') columns!:QueryList<TemplateRef<any>>;
  @Input() loading = false;


}
